import React from "react";
import { CardProductCompact } from "../CardProductCompact/CardProductCompact";
import type { ProductReference } from "../../types/types.PIM";
import { ReferenceHoverTooltip } from "../ReferenceHoverTooltip";

interface ProductReferenceMockTooltipProps {
  productRef: ProductReference;
  children: React.ReactElement;
  isPortfolio?: boolean;
  storePath?: string;
  adminPath?: string;
}

export const ProductReferenceMockTooltip = ({
  productRef,
  children,
  isPortfolio,
  storePath,
  adminPath,
}: ProductReferenceMockTooltipProps) => {
  const getHref = (product: ProductReference) => {
    if (isPortfolio && storePath) {
      return `${storePath}/product/${product.slug}`;
    }
    if (!isPortfolio && adminPath) {
      return `${adminPath}/pim/products/${
        product.product_number ?? product.id
      }`;
    }
    const base = window.location.pathname.startsWith("/store")
      ? "/store"
      : "/admin";
    return base === "/store"
      ? `${base}/product/${product.slug}`
      : `${base}/pim/products/${product.product_number ?? product.id}`;
  };

  return (
    <ReferenceHoverTooltip
      placement="side"
      variant="card"
      content={
        <CardProductCompact
          product={productRef}
          href={getHref(productRef)}
          variant="tooltip"
        />
      }
    >
      {children}
    </ReferenceHoverTooltip>
  );
};
